module.exports = __webpack_public_path__ + "static/media/logo_white@3x.430f3265.png";